import { formatUnits, weiUnits } from 'viem'
import { getPublicClient } from '@wagmi/core'

import { increaseForLondonFork } from 'utils/crypto'

import { CHAIN_INFO, RPC_LIST } from 'constants/chains'

import { estimateFees } from './estimateGas'

import { FetchFeeDataArgs, FetchFeeDataResult } from './types'

export function getUnit(unit: 'gwei' | 'wei') {
  if (unit === 'wei') {
    return 0
  }
  return Math.abs(weiUnits[unit])
}

export async function fetchFeeData({
  chainId,
  formatUnits: units = 'gwei',
}: FetchFeeDataArgs = {}): Promise<FetchFeeDataResult> {
  const publicClient = getPublicClient({
    chainId,
  })

  const block = await publicClient.getBlock()

  let gasPrice: bigint | null = null
  let maxFeePerGas: bigint | null = null
  let maxPriorityFeePerGas: bigint | null = null

  if (chainId && CHAIN_INFO[chainId].isEstimateGas) {
    const estimateFeesResult = await estimateFees(block, RPC_LIST[chainId as SupportedChainId])
    maxPriorityFeePerGas = estimateFeesResult.maxPriorityFeePerGas
    maxFeePerGas = estimateFeesResult.maxFeePerGas ? increaseForLondonFork(estimateFeesResult.maxFeePerGas) : null
  } else {
    gasPrice = await publicClient.getGasPrice()
  }

  const unit = getUnit(units)

  const formatted = {
    gasPrice: gasPrice ? formatUnits(gasPrice, unit) : null,
    maxFeePerGas: maxFeePerGas ? formatUnits(maxFeePerGas, unit) : null,
    maxPriorityFeePerGas: maxPriorityFeePerGas ? formatUnits(maxPriorityFeePerGas, unit) : null,
  }

  return {
    gasPrice,
    formatted,
    maxFeePerGas,
    maxPriorityFeePerGas,
  }
}
